import { useEffect, useState } from 'react';
import { useInterval } from 'react-use';

// Types
import type { Config } from 'mixpanel-browser';
import mixpanel from 'mixpanel-browser';

// Components
import MixPanelInitializeUser from './MixPanelInitializeUser';

const RECORD_MAX_MS = 600000;
const RECORD_MIN_MS = 4000;
const MAX_PERCENT_RECORD_SESSIONS_PERCENT = 20;

export function MixPanelInitialize() {
    const [trackAnalytics, setTrackAnalytics] = useState(false);
    const [hubspotDelay, setHubspotDelay] = useState<number | null>(500);

    const defaultMixPanelConfig: Partial<Config> = {
        persistence: 'localStorage',
        record_mask_text_selector: '',
        record_max_ms: RECORD_MAX_MS,

        // @ts-ignore
        record_min_ms: RECORD_MIN_MS,
        ignore_dnt: true //bypass the do not track browser setting
    };

    useEffect(() => {
        if (!window?.mixpanel) {
            window.mixpanel = mixpanel;
        }

        return () => {
            if (window?.mixpanel) {
                delete window.mixpanel;
            }
        };
    }, []);

    useEffect(() => {
        // Active or deactivate session recording
        mixpanel?.set_config({
            record_sessions_percent: trackAnalytics ? MAX_PERCENT_RECORD_SESSIONS_PERCENT : null
        });
    }, [trackAnalytics]);

    useInterval(() => {
        // wait for HubSpot to be fully loaded
        if (window?._hsp) {
            window._hsp.push([
                'addPrivacyConsentListener',
                function (bannerInfo) {
                    setTrackAnalytics(bannerInfo?.categories?.analytics);
                }
            ]);
            setHubspotDelay(null); // Stop the interval
        }
    }, hubspotDelay);

    mixpanel?.init(
        process.env.NEXT_PUBLIC_MIXPANEL_API_KEY,
        process.env.NEXT_PUBLIC_MIXPANEL_API_HOST
            ? { ...defaultMixPanelConfig, api_host: process.env.NEXT_PUBLIC_MIXPANEL_API_HOST }
            : defaultMixPanelConfig
    );

    return <MixPanelInitializeUser />;
}
